// eslint-disable-next-line import/prefer-default-export
export const notificationOptions = { allowRedirect: true, dontGrayscalePage: true };
